import { render, staticRenderFns } from "./ExOrgPosition.vue?vue&type=template&id=0b8d8a5a&scoped=true"
import script from "./ExOrgPosition.vue?vue&type=script&lang=js"
export * from "./ExOrgPosition.vue?vue&type=script&lang=js"
import style0 from "./ExOrgPosition.vue?vue&type=style&index=0&id=0b8d8a5a&prod&lang=css"
import style1 from "./ExOrgPosition.vue?vue&type=style&index=1&id=0b8d8a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8d8a5a",
  null
  
)

export default component.exports